import styled, { keyframes } from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, spacing, breakpoints } = globalStyles;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.space32};
`;

export const PageTitle = styled.h1`
  margin: 0 ${spacing.space24} ${spacing.space24} ${spacing.space24};

  @media (min-width: ${breakpoints.s}) {
    text-align: center;
  }
`;

export const ContainerOne = styled.div`
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
  height: 250px;
  margin-top: ${spacing.space32};
  gap: 200px;

  @media (max-width: ${breakpoints.l}) {
    gap: 100px;
  }

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: ${spacing.space32};
  }
`;

export const ContainerTwo = styled.div`
  width: 100vw;
  max-width: 100%;
  min-height: 500px;
  background-color: ${colors.primary.green};
  margin-top: ${spacing.space32};
  align-content: center;
  overflow: hidden;
  padding: ${spacing.space32} 0;

  @media (max-width: ${breakpoints.m}) {
    min-height: 450px;
  }
`;

export const ContainerThree = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  min-height: 350px;
  gap: ${spacing.space32};
  padding-top: ${spacing.space32};
  margin-bottom: ${spacing.space32};
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.m}) {
    min-height: 100px;
    justify-content: center;
    padding-top: ${spacing.space32};
    margin-bottom: ${spacing.space32};
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    max-width: 1200px;
  }

  img {
    max-width: 1200px;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  color: ${colors.primary.black};
  font-size: 1.3rem;
  padding: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    &:first-child {
      margin-top: ${spacing.space32};
    }

    &:last-child {
      margin-bottom: ${spacing.space32};
    }
  }
`;

export const StyledText = styled.p`
  max-width: 350px;
  margin-top: -${spacing.space16};
`;

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const SkeletonLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 620px;
  box-sizing: border-box;
  background: linear-gradient(to right, #e0e0e0 0%, #c6c6c6 50%, #e0e0e0 100%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.5s infinite;

  @media (max-width: ${breakpoints.m}) {
    height: 320px;
  }

  @media (max-width: ${breakpoints.s}) {
    height: 220px;
  }
`;

export const PartnerImageCard = styled.div`
  border-radius: ${spacing.space12};
  padding: ${spacing.space32};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: 0 ${spacing.space24};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
`;
